import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50" }
const _hoisted_2 = { class: "container mx-auto px-6 py-12" }
const _hoisted_3 = { class: "bg-white p-8 rounded-lg shadow-md" }
const _hoisted_4 = {
  class: "prose",
  style: {"text-align":"left"}
}
const _hoisted_5 = { class: "list-decimal list-inside text-gray-700 ml-4 space-y-4 mb-6" }
const _hoisted_6 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Disclaimer',
  setup(__props) {

// 法律声明页面组件

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg-white border-b" }, [
      _createElementVNode("div", { class: "container mx-auto px-6 py-8" }, [
        _createElementVNode("h1", { class: "text-3xl font-bold text-gray-900" }, "法律声明"),
        _createElementVNode("p", { class: "text-gray-600 mt-2" }, "更新日期：2025年9月10日")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-gray-700 mb-6" }, " 欢迎访问北境骑团官方网站（以下称\"本网站\"），本网站的服务（以下或称\"本服务\"）由北境骑团提供。请您仔细阅读、充分理解以下条款，特别是 \"权利声明\"条款、\"免责条款\"条款以及\"适用法律及争议解决\"条款。您访问、浏览和/或使用本网站，代表您同意接受以下条款；如果您不同意接受以下条款，请立即停止访问、浏览和使用本网站。我们保留随时修改这些条款的权利。 ", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-2xl font-bold text-gray-900 mt-8 mb-4" }, "一、权利声明", -1)),
          _createElementVNode("ol", _hoisted_5, [
            _createElementVNode("li", null, [
              _cache[0] || (_cache[0] = _createTextVNode(" 本网站上的 \"北境骑团\"、\"BJQTEAM\"、\"")),
              _createElementVNode("img", {
                src: require('../assets/logo.png'),
                alt: "北境骑团品牌图标",
                style: {"display":"inline","height":"1.2em","vertical-align":"middle","margin":"0 4px"}
              }, null, 8, _hoisted_6),
              _cache[1] || (_cache[1] = _createTextVNode("\"等文字及/或标识，以及本网站上的其他标识、徽记、产品和服务名称均为我们及我们的关联公司在中国和其他国家的注册商标。未经权利人书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。 "))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("li", null, " 本网站所有的产品、服务、技术与所有程序的知识产权均归属于我们或归其权利人所有。 ", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("li", null, " 除非我们另行声明，我们拥有我们在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经权利人许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载本网站内的任何内容）。被授权浏览、复制、打印和传播属于本网站内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。 ", -1))
          ]),
          _cache[6] || (_cache[6] = _createStaticVNode("<h2 class=\"text-2xl font-bold text-gray-900 mt-8 mb-4\" data-v-12b8517d>二、免责条款（除非法律有强制性的规定不得免责）</h2><ol class=\"list-decimal list-inside text-gray-700 ml-4 space-y-4 mb-6\" data-v-12b8517d><li data-v-12b8517d> 本网站上的所有资料仅供用户参考，不应视作投资建议或任何形式的投资招揽。对本网站的内容，我们已尽最大努力的审核，但不提供任何形式的明示的或默示的关于内容的正确性、及时性、有效性、稳定性、可用性、不侵犯他人权利等方面的保证；不保证服务器的稳定性，不保证您任何时候均可浏览、阅读、复制、使用本网站；不保证网站内容所包含的文字、图形、材料、链接、说明、陈述或其它事项的准确性或完整性，也不保证本网站的内容不存在打印、复制及其他输入方面的错误。 </li><li data-v-12b8517d> 在任何情况下，对于因使用本网站内容或无法进入本网站而导致的任何直接的、间接的、附带的、给第三人造成的损失(包括但不限于利润损失、信息数据丢失、财产毁坏等损失)，本网站均无须承担法律责任，不论是采用合同之诉、侵权之诉或其他诉讼理由。 </li><li data-v-12b8517d> 为方便您使用，本网站设立了同第三方所有和运营而非我们维护的其他网站之间的链接。尽管如此，即使上述第三方是我们的关联方，我们对链接网站也不行使任何控制权，我们不对任何链接网站的内容负有责任，也不对此类网站提供材料的内容或真实性做出任何声明。本网站用户对于如何使用该等网站，需做出个人的独立判断。 </li><li data-v-12b8517d> 本网站中有关北境骑团未来业务的任何前瞻性声明本质上都属于根据现有信息、经营计划和对未来形势和趋势的预测而做出的推断，受许多风险和不确定因素的影响，我们可能会根据市场或其他因素随时自行决定更改，并且无意以任何方式对未来提供的服务、计划做出承诺。 </li></ol><h2 class=\"text-2xl font-bold text-gray-900 mt-8 mb-4\" data-v-12b8517d>三、适用法律及争议解决</h2><ol class=\"list-decimal list-inside text-gray-700 ml-4 space-y-4 mb-6\" data-v-12b8517d><li data-v-12b8517d> 本网站及本法律声明的成立、生效、解释及纠纷解决，适用中华人民共和国法律。若您和我们发生任何纠纷或争议，首先应友好协商解决；协商不成的，双方均同意将纠纷或争议提交有管辖权的人民法院解决。 </li><li data-v-12b8517d> 本法律声明任一条款被视为废止、无效或不可执行，该条应视为可分的且不影响本法律声明其余条款的有效性及可执行性。 </li></ol><p class=\"text-gray-700 mt-8\" data-v-12b8517d> 如果您对本法律声明有任何疑问，请通过网站上的联系方式与我们联系。 </p>", 5))
        ])
      ])
    ])
  ]))
}
}

})